import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { DuplicateExecuteApi } from '../../apis/duplicate-execute-api';
import type { DuplicateExecuteRepository } from '../../services/share-tools-repository';

@injectable()
export class DuplicateExecuteRepositoryImpl implements DuplicateExecuteRepository {
    constructor(
        @inject(DuplicateExecuteApi) private duplicateExecuteApi: DuplicateExecuteApi
    ) {
    }

    executeShareTask(data: string) {
        return this.duplicateExecuteApi.executeShareTask(data);
    }
}
